import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import Auth from "./Auth";
import Notes from "./Notes";
import Contact from "./Contact";
import Common from "./Common";
import Chat from "./Chat";
import Spares from "./Spares";
import ClientTicket from "./ClientTicket";
import ClientProject from "./ClientProject";
import Tasks from "./Tasks";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    auth: Auth,
    notes: Notes,
    contact: Contact,
    common: Common,
    chat: Chat,
    spares: Spares,
    clientTicket: ClientTicket,
    clientProject: ClientProject,
    tasks: Tasks,
  });

export default createRootReducer;
